import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";

import { apiClient } from "../api/client";
import { SalesDataResponse } from "../api/PartnerPortalGatewayApi";

interface UseDailyAttendanceResult {
  data: SalesDataResponse[];
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useDailyAttendance = (
  serviceId: number | null,
  startDate?: dayjs.Dayjs,
  endDate?: dayjs.Dayjs,
): UseDailyAttendanceResult => {
  // Default to last 2 months if no dates provided
  const defaultEndDate = dayjs();
  const defaultStartDate = dayjs().subtract(2, "month");

  const finalStartDate = startDate || defaultStartDate;
  const finalEndDate = endDate || defaultEndDate;

  const {
    data: queryData,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["dailyAttendance", serviceId, finalStartDate.format("YYYY-MM-DD"), finalEndDate.format("YYYY-MM-DD")],
    queryFn: async (): Promise<SalesDataResponse[]> => {
      if (!serviceId) {
        return [];
      }

      const response = await apiClient.attendance.getDailyAttendanceNumbersByService(
        serviceId,
        finalStartDate,
        finalEndDate,
      );

      console.log("Daily Attendance API Response:", response);

      return response || [];
    },
    enabled: !!serviceId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    data: queryData || [],
    loading: isLoading,
    error: error?.message || null,
    refetch,
  };
};
